import {
  Graph,
  BasicInfo,
  Historicity,
  } from './components';

export const stepsBeneficiary = [
  {
    name: 'GRAPH',
    label: 'Συνοπτική Παρουσίαση Κατάστασης Αίτησης',
    Component: Graph,
    id: 0,
  },
  {
    name: 'INFO',
    label: 'Στοιχεία Αίτησης',
    Component: BasicInfo,
    id: 1,
  },
  {
    name: 'HISTORICITY',
    label: 'Ιστορικότητα',
    Component: Historicity,
    id: 3,
  },
  ];